import type { MenuItemProps } from '@mui/material'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { graphHooks } from '@tunasong/graph-lib/react'
import { MeetingRoom } from '@tunasong/icons'
import type { FC } from 'react'

export interface RoomMenuProps extends Omit<MenuItemProps, 'button'> {
  entityId?: string
  open?: boolean
}

export const RoomMenu: FC<RoomMenuProps> = props => {
  const { entityId, open = false, ...restProps } = props
  const { entity } = graphHooks.useEntity(entityId)

  if (!entity) {
    return null
  }

  return (
    <MenuItem title={`Video collaboration for ${entity.type}: ${entity.name}`} color="inherit" {...restProps}>
      <ListItemIcon>
        <MeetingRoom color={open ? 'secondary' : 'inherit'} />
      </ListItemIcon>
      <ListItemText>Video Room</ListItemText>
    </MenuItem>
  )
}

export default RoomMenu
